<script>
    import { onMount } from "svelte";

    import {
        CustomTooltip,
        Loader,
    } from "../../../Components/Common/index.svelte";

    import {
        getAmountInCurrency,
        isObjectEmpty,
    } from "../../../Utils/utilFunctions.svelte";

    import BarChart from "../../../Components/Charts/BarChart.svelte";

    export let dashboardData = {},
        filters = {};

    let isParsingData = true;

    let totalPendingPaymentAmount = 0,
        chartData = [],
        labelArr = [];

    onMount(() => {
        if (dashboardData && !isObjectEmpty(dashboardData))
            syncPendingPaymentDetails(dashboardData);
        else isParsingData = false;
    });

    const syncPendingPaymentDetails = (data) => {
        const { allPendingPaymentsOverview } = data;

        if (!allPendingPaymentsOverview || !allPendingPaymentsOverview.length) {
            isParsingData = false;
            return;
        }

        allPendingPaymentsOverview.map((overview) => {
            totalPendingPaymentAmount += overview.totalPendingPayments;

            labelArr.push(overview.daysOld);
            chartData.push(overview.totalPendingPayments);
        });

        isParsingData = false;
    };
</script>

<div class="flex flex-col flex-1 gap-4 p-4">
    <div class="flex w-full items-center gap-x-4">
        <div class="flex flex-1 items-center gap-x-2">
            <p>Payments pending (all time)</p>
            <CustomTooltip>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    class="stroke-current shrink-0 w-4 h-4"
                    slot="tooltipTrigger"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                </svg>

                <div>
                    <p>
                        Payments Pending are unpaid quotes or invoices that have
                        been sent to Patients, Health Funds and Third parties.
                    </p>

                    <p>
                        Formula = Sum of Quotes from Active Encounters with
                        Status: "Quoted" PLUS Sum of Invoices from Active
                        Encounters with Status: "In Progress" MINUS Sum of
                        Payments Received with Encounter Status: "In Progress"
                    </p>
                </div>
            </CustomTooltip>
        </div>

        <div
            class="flex flex-1 items-center justify-end gap-x-2 text-md font-bold cursor-default"
        >
            <p>Pending total:</p>
            {#if isParsingData}
                <Loader />
            {:else}
                <p>{getAmountInCurrency(totalPendingPaymentAmount)}</p>
            {/if}
        </div>
    </div>

    <div class="flex flex-1">
        {#if isParsingData}
            <div class="flex flex-1 items-center text-center">
                Parsing chart data
            </div>
        {:else if !chartData.length}
            <div class="flex flex-1 items-center text-center">
                No payments to show
            </div>
        {:else}
            <div class="flex flex-1 h-[300px]">
                <BarChart
                    bind:chartData
                    labels={labelArr}
                    isResponsive={false}
                    width="full"
                    height="full"
                    title="Pending Payments"
                />
            </div>
        {/if}
    </div>
</div>
